module.exports = __webpack_public_path__ + "static/media/background-2.a89a6c8e.jpg";